import request from "@/utils/request";

export function listBanner() {
    return request({
        url: '/app/banner-list',
        method: 'get'
    })
}
